"use strict";

exports.__esModule = true;
exports.DeviceColorSourcePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../../Core");
var _Metrics = require("../../../Metrics");
var _Measures = require("../../../Measures");
var _DeviceValueColorSource = require("../DeviceValueColorSource");
var _ColorPicker = require("../../../Form/ColorPicker");
var _class, _DeviceColorSourcePicker;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Allows the user to select a color source.
 */
var DeviceColorSourcePicker = exports.DeviceColorSourcePicker = (0, _Core.withTranslator)(_class = (0, _styledComponents.withTheme)(_class = (_DeviceColorSourcePicker = /*#__PURE__*/function (_Component) {
  function DeviceColorSourcePicker() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleChange = function () {};
    _this.handleNoneClick = function () {
      var onChange = _this.props.onChange;
      onChange(undefined);
    };
    _this.handleCycleClick = function () {
      var onChange = _this.props.onChange;
      onChange({
        type: "timeseries",
        name: "cycle",
        thresholds: []
      });
    };
    _this.handleRawValueClick = function () {
      var onChange = _this.props.onChange;
      onChange({
        type: "rawValue",
        name: "rawValue",
        thresholds: [],
        backgroundColorValueTuples: []
      });
    };
    _this.handleCustomColorClick = function () {
      var _this$props = _this.props,
        theme = _this$props.theme,
        onChange = _this$props.onChange;
      onChange({
        type: "custom",
        name: "custom",
        thresholds: [],
        backgroundColorValueTuples: [],
        customColor: theme.DefaultValueCustomColor
      });
    };
    _this.handlePlantStateColorClick = function () {
      var onChange = _this.props.onChange;
      onChange({
        type: "plantState",
        name: "plantState",
        thresholds: [],
        backgroundColorValueTuples: []
      });
    };
    _this.handleMetricClick = function () {
      var _this$props2 = _this.props,
        theme = _this$props2.theme,
        onChange = _this$props2.onChange;
      // The legacy pastels; under the modern UI the state tokens they stand for.
      var state = function state(token, legacy) {
        return theme && theme.uiModern && theme[token] ? theme[token] : legacy;
      };
      onChange({
        type: "metric",
        name: "utilization",
        thresholds: [[15, state("UnplannedDowntimeStateColor", "#f6928f")], [50, state("PlannedDowntimeStateColor", "#fbbc6d")], [80, state("ProducingStateColor", "#6fc376")]]
      });
    };
    _this.handleMetricChange = function (selected) {
      var _this$props3 = _this.props,
        value = _this$props3.value,
        onChange = _this$props3.onChange;
      if (selected.length === 0 || !value || value.type !== "metric") {
        return;
      }
      onChange(Object.assign({}, value, {
        name: selected[0].name
      }));
    };
    _this.handleThresholdChange = function (thresholds) {
      var _this$props4 = _this.props,
        value = _this$props4.value,
        onChange = _this$props4.onChange;
      if (value) {
        onChange(Object.assign({}, value, {
          thresholds: thresholds
        }));
      }
    };
    _this.handleRawValueChange = function (backgroundColorValueTuples) {
      var _this$props5 = _this.props,
        value = _this$props5.value,
        onChange = _this$props5.onChange;
      if (value) {
        onChange({
          backgroundColorValueTuples: backgroundColorValueTuples,
          name: "rawValue",
          type: "rawValue",
          thresholds: []
        });
      }
    };
    _this.handleCustomColorChange = function (customColor) {
      var _this$props6 = _this.props,
        value = _this$props6.value,
        onChange = _this$props6.onChange;
      if (value) {
        onChange(Object.assign({}, value, {
          customColor: customColor
        }));
      }
    };
    _this.wrapControlGroup = function (component, popover, width) {
      return /*#__PURE__*/_react["default"].createElement(_core.ControlGroup, {
        vertical: true,
        style: {
          width: width
        }
      }, popover, component);
    };
    _this.metricFieldRenderer = function (popover) {
      var _this$props7 = _this.props,
        value = _this$props7.value,
        width = _this$props7.width,
        height = _this$props7.height;
      if (!value) {
        return null;
      }
      return _this.wrapControlGroup(/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Metrics.MetricSelector, {
        className: _core.Classes.FILL,
        itemPredicate: itemPredicate,
        selected: [value.name],
        onSelect: _this.handleMetricChange
      }), /*#__PURE__*/_react["default"].createElement(_Measures.ThresholdPicker, {
        usePopover: true,
        gradientProps: {
          style: {
            width: width,
            height: height
          }
        },
        value: value.thresholds,
        onChange: _this.handleThresholdChange
      })), popover, width);
    };
    _this.rawValueFieldRenderer = function (popover) {
      var _this$props8 = _this.props,
        value = _this$props8.value,
        width = _this$props8.width;
      if (!value) {
        return null;
      }
      return _this.wrapControlGroup(/*#__PURE__*/_react["default"].createElement(_DeviceValueColorSource.DeviceValueColorSource, {
        value: value.backgroundColorValueTuples || [],
        onChange: _this.handleRawValueChange
      }), popover, width);
    };
    _this.customFieldRenderer = function (popover) {
      var _this$props9 = _this.props,
        value = _this$props9.value,
        width = _this$props9.width;
      if (!value) {
        return null;
      }
      return _this.wrapControlGroup(/*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: "fit-content",
          margin: "5px 0"
        }
      }, /*#__PURE__*/_react["default"].createElement(_ColorPicker.ColorPicker, {
        value: value.customColor,
        onChange: _this.handleCustomColorChange
      })), popover, width);
    };
    _this.plantStateFieldRenderer = function (popover) {
      var _this$props0 = _this.props,
        value = _this$props0.value,
        width = _this$props0.width;
      if (!value) {
        return null;
      }
      return _this.wrapControlGroup(null, popover, width);
    };
    return _this;
  }
  _inheritsLoose(DeviceColorSourcePicker, _Component);
  var _proto = DeviceColorSourcePicker.prototype;
  _proto.render = function render() {
    var _this$props1 = this.props,
      value = _this$props1.value,
      translator = _this$props1.translator,
      width = _this$props1.width,
      allowCurrentCycle = _this$props1.allowCurrentCycle;
    var translate = translator.translate;
    var translations = {
      none: translate("DeviceColorSourcePicker.kind.none", "No Color"),
      metric: translate("DeviceColorSourcePicker.kind.metric", "Metric Color"),
      timeseries: translate("DeviceColorSourcePicker.kind.timeseries", "Cycle Color"),
      rawValue: translate("DeviceColorSourcePicker.kind.rawValueBgColor", "Value Color"),
      plantState: translate("DeviceColorSourcePicker.kind.plantStateBgColor", "State Color"),
      custom: translate("DeviceColorSourcePicker.kind.customValueBgColor", "Custom Color")
    };
    var selectedText = value && value.type && translations[value.type] ? translations[value.type] : translations.none;
    var popover = /*#__PURE__*/_react["default"].createElement(_core.Popover, {
      minimal: true,
      content: /*#__PURE__*/_react["default"].createElement(_core.Menu, null, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        style: {
          width: width
        },
        text: translations.none,
        onClick: this.handleNoneClick
      }), /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        text: translations.custom,
        onClick: this.handleCustomColorClick
      }), allowCurrentCycle && /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        text: translations.timeseries,
        onClick: this.handleCycleClick
      }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        text: translations.metric,
        onClick: this.handleMetricClick
      }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        text: translations.plantState,
        onClick: this.handlePlantStateColorClick
      }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        text: translations.rawValue,
        onClick: this.handleRawValueClick
      }))
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.STYLE,
      text: selectedText,
      style: {
        width: width
      }
    }));
    var renderers = {
      metric: this.metricFieldRenderer(popover),
      rawValue: this.rawValueFieldRenderer(popover),
      custom: this.customFieldRenderer(popover),
      plantState: this.plantStateFieldRenderer(popover),
      timeseries: popover
    };
    return value && value.type && renderers[value.type] ? renderers[value.type] : popover;
  };
  return DeviceColorSourcePicker;
}(_react.Component), _DeviceColorSourcePicker.defaultProps = {
  allowCurrentCycle: true,
  width: 256,
  height: 48,
  translator: undefined,
  theme: undefined
}, _DeviceColorSourcePicker)) || _class) || _class;
function itemPredicate(query, item) {
  if (item.units !== "PERCENT" && item.units !== "FRACTIONAL_PERCENT") {
    return false;
  }
  var q = query.toLowerCase();
  return item.name.toLowerCase().indexOf(q) !== -1 || item.label.toLowerCase().indexOf(q) !== -1 || item.description.toLowerCase().indexOf(q) !== -1;
}